export default {"src":"/_next/static/media/duckiconblack.fd3f0462.svg","height":64,"width":64};